import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    DuplicateStagesetForModal as DuplicateStagesetForModalMutation,
    DuplicateStagesetForModalVariables as DuplicateStagesetForModalVariables,
    DuplicateStagesetInput,
} from 'nutshell-graphql-types';

import DUPLICATE_STAGESET_FOR_MODAL from '../mutations/duplicate-stageset-for-modal.graphql';

export const useDuplicateStagesetForModal = (): {
    duplicateStageset: (arg1: DuplicateStagesetInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [duplicateStageset, {loading, error}] = useMutation<
        DuplicateStagesetForModalMutation,
        DuplicateStagesetForModalVariables
    >(DUPLICATE_STAGESET_FOR_MODAL);

    return {
        duplicateStageset: (input: DuplicateStagesetInput) =>
            duplicateStageset({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
